module.exports = "https://web-assets.ifttt.com/packs/media/feedback/thumbs-up-d22a6093.svg";